import { get } from "lodash";
import { store } from "@irati/store";
import isSamlUserHelper from "@irati/identity/helpers/user/isSamlUser";
import locale from "@irati/utils/locale";
import { CurrencyType } from "@irati/payments/enums";
import paymentProviderForCountryCode from "@irati/payments/helpers/paymentProviderForCountryCode";
import { isGlobalAdmin as isGlobalAdminHelper } from "@irati/identity/helpers/user/role";
import getDeviceLocale from "@irati/utils/lang/helpers/getDeviceLocale";
import AuthService from "./streams/auth";
import UnauthedService from "./streams/unauthed";
var apps = function (key) {
    if (key === void 0) { key = ""; }
    try {
        var auth = AuthService.get();
        return key.length ? get(auth.productPermissions, key, false) : auth.productPermissions;
    }
    catch (e) {
        return false;
    }
};
var userProducts = function () {
    var _a = apps(), perks = _a.perks, recognition = _a.recognition, medical = _a.medical, insights = _a.insights;
    return [
        {
            product: "perks",
            active: !!perks
        },
        {
            product: "recognition",
            active: !!recognition
        },
        {
            product: "medical",
            active: !!medical
        },
        {
            product: "insights",
            active: !!insights
        }
    ];
};
var user = function () {
    var auth = AuthService.get();
    return auth.user;
};
var userTenant = function (key) {
    if (key === void 0) { key = ""; }
    var auth = AuthService.get();
    return key.length ? get(auth.userTenant, key, false) : auth.userTenant;
};
var business = function () {
    var auth = AuthService.get();
    return auth.business;
};
var unAuthedBusiness = function () {
    var auth = UnauthedService.get();
    return auth.unauthedBusiness;
};
var upsell = function () {
    var auth = store.getState().auth;
    return auth.upsell || {};
};
var userUnits = function () {
    // @todo: Need to integrate a proper units system. Hardcoding for now.
    return {
        distance: locale.units.miles
    };
};
var featureFlag = function (key) {
    var auth = store.getState().auth;
    return get(auth.featureFlags, key, false);
};
var userLocale = function () {
    try {
        return user().language || getDeviceLocale();
    }
    catch (e) {
        return getDeviceLocale();
    }
};
var userPaymentProvider = function () {
    return paymentProviderForCountryCode();
};
var defaultUserCurrency = function () {
    switch (userLocale()) {
        case "fr-FR":
            return CurrencyType.EUR;
        case "en-AU":
            return CurrencyType.AUD;
        case "en-GB":
        default:
            return CurrencyType.GBP;
    }
};
var isSamlUser = function () {
    return isSamlUserHelper(user());
};
var isLoggedIn = function () {
    try {
        AuthService.get();
        return true;
    }
    catch (e) {
        return false;
    }
};
var isGlobalAdmin = function () {
    try {
        return isGlobalAdminHelper(business(), user());
    }
    catch (e) {
        return false;
    }
};
var hasAdminAccess = function () {
    return !!apps().admin;
};
var isUserGhost = function () {
    return apps("ghost.isGhost") || false;
};
var authentication = {
    // user related
    user: user,
    userLocale: userLocale,
    userPaymentProvider: userPaymentProvider,
    userProducts: userProducts,
    business: business,
    unAuthedBusiness: unAuthedBusiness,
    userUnits: userUnits,
    defaultUserCurrency: defaultUserCurrency,
    isGlobalAdmin: isGlobalAdmin,
    // meta/unsure
    isLoggedIn: isLoggedIn,
    isSamlUser: isSamlUser,
    isUserGhost: isUserGhost,
    upsell: upsell,
    apps: apps,
    hasAdminAccess: hasAdminAccess,
    // to be deprecated
    userTenant: userTenant,
    featureFlag: featureFlag
};
export default authentication;
